import Base from 'app/models/base';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('events'),
  rootKey: 'event',
});



// WEBPACK FOOTER //
// ./app/models/event.js